import { useEffect, useRef, useState } from "react";
import {
  LiaHornbill,
  LiaSearchPlusSolid,
  LiaSearchSolid,
} from "react-icons/lia";
import { MdClose, MdEdit, MdModeEdit } from "react-icons/md";
import { aging } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import AgingForm from "./AgingForm";
import { HiOutlinePlus } from "react-icons/hi";
import Button from "../../common/Button";
import {
  IoIosSave,
  IoMdArrowDropdown,
  IoMdArrowDropright,
} from "react-icons/io";
import { AiOutlineCheck } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { RiHistoryLine } from "react-icons/ri";
import { LayoutGrid } from "lucide-react";
import { formatDate } from "../../utlis/formateDate";

const Aging = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAgingData, setIsAgingData] = useState([]);
  const [isQcDoneData, setIsQcDoneData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const pageSize = 10;
  const [formData, setFormData] = useState({
    aging_No: 0,
    aging_Date: "",
    start_Gas_Reading: "",
    end_Gas_Reading: "",
    total_Consumption: "",
    temperature: "",
    shift: "",
    in_Time: "",
    out_Time: "",
    total_Time: "",
    created_By: userId,
    agingDetails: [
      {
        aging_No: 0,
        seq_No: 0,
        batch_Id: "",
        cut_Length: "",
        quantity: "",
        hardness: "",
        remark: "",
        die_Id: "",
        casting_No: "",
        po_No: "",
      },
    ],
  });
  const [selectedQcData, setSelectedQcData] = useState(null);
  const [isActiveTab, setIsActiveTab] = useState("qc-done");
  const [adding, setAdding] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSeqs, setSelectedSeqs] = useState([]);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [editingRows, setEditingRows] = useState(new Set());
  const [draftRows, setDraftRows] = useState({});
  const tableScrollRef = useRef(null);
  const isFetchingRef = useRef(false);
  const [qcHasMore, setQcHasMore] = useState(true);
  const [agingHasMore, setAgingHasMore] = useState(true);
  const [qcPage, setQcPage] = useState(1);
  const [agingPage, setAgingPage] = useState(1);

  const cancelEdit = (id) => {
    setEditingRows((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
    setDraftRows((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };
  const parseTimeToMinutes = (t) => {
    if (!t) return null;
    const [h = 0, m = 0] = String(t).split(":").map(Number);
    return h * 60 + m;
  };

  const parseDurationToMinutes = (v) => {
    if (v === "" || v == null) return null;
    const s = String(v).trim();

    if (s.includes(":")) {
      const [h = 0, m = 0] = s.split(":").map(Number);
      return h * 60 + m;
    }
    const n = Number(s);
    if (Number.isFinite(n)) return Math.round(n * 60);

    return null;
  };

  const minutesToHHMM = (mins) => {
    const m = ((mins % 1440) + 1440) % 1440;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return String(h).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
  };
  const changeDraft = (id, field, value) => {
    setDraftRows((prev) => {
      const base = prev[id] ?? {};
      const next = { ...base, [field]: value };

      if (field === "start_Gas_Reading" || field === "end_Gas_Reading") {
        const s = Number(next.start_Gas_Reading || 0);
        const e = Number(next.end_Gas_Reading || 0);
        next.total_Consumption = e - s;
      }
      const startMins = parseTimeToMinutes(next.in_Time);
      const durMins = parseDurationToMinutes(next.out_Time);

      if (startMins != null && durMins != null) {
        next.total_Time = minutesToHHMM(startMins + durMins);
      } else {
        next.total_Time = "";
      }
      return { ...prev, [id]: next };
    });
  };

  const toggleExpand = (id) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const fetchAgingData = async (page) => {
    setLoading(true);
    try {
      const res = await aging.getAllAging(page, pageSize);

      setIsAgingData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setAgingHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const fetchQcDoneData = async (page) => {
    setLoading(true);
    try {
      const res = await aging.getAllQcDone(page, pageSize);
      setIsQcDoneData((prev) => {
        return page === 1 ? res.data || [] : [...prev, ...(res.data || [])];
      });

      if (!res.data || res.data.length < pageSize) {
        setQcHasMore(false);
      }
      isFetchingRef.current = false;
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const handleTabChange = (tab) => {
    setIsActiveTab(tab);
    if (tab === "sales") {
      setQcPage(1);
      setIsQcDoneData([]);
      setQcHasMore(true);
    } else {
      setAgingPage(1);
      setIsAgingData([]);
      setAgingHasMore(true);
    }
  };

  useEffect(() => {
    if (isActiveTab === "qc-done") fetchQcDoneData(qcPage);
  }, [qcPage, isActiveTab]);

  useEffect(() => {
    if (isActiveTab === "aging") fetchAgingData(agingPage);
  }, [agingPage, isActiveTab]);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return;

    const onScroll = () => {
      if (loading || isFetchingRef.current) return;

      const { scrollTop, clientHeight, scrollHeight } = el;

      if (scrollHeight - scrollTop <= clientHeight + 100) {
        isFetchingRef.current = true;

        if (isActiveTab === "qc-done" && qcHasMore) {
          setQcPage((p) => p + 1);
        }

        if (isActiveTab === "aging" && agingHasMore) {
          setAgingPage((p) => p + 1);
        }
      }
    };

    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [isActiveTab, loading, qcHasMore, agingHasMore]);

  const handleConfirmDelete = async () => {
    try {
      await aging.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchAgingData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };
  const toDecimal = (v) => {
    if (v === null || v === undefined) return null;
    const s = String(v).trim();
    if (s === "") return null;
    const n = parseFloat(s.replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
  };
  const pickDetails = (src) => {
    const raw = src?.agingDetails ?? src?.details ?? [];
    if (!Array.isArray(raw) || raw.length === 0) return null;

    return raw.map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? src.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? 0,
      quantity: toDecimal(d.quantity) ?? 0,
      hardness: toDecimal(d.hardness) ?? 0,
      remark: d.remark ?? "",
      po_No: d.po_No ?? null,
      approved_Pcs: d.approved_Pcs ?? 0,
    }));
  };
  const buildPayload = (src) => {
    const start = toDecimal(src.start_Gas_Reading) ?? 0;
    const end = toDecimal(src.end_Gas_Reading) ?? 0;

    const payload = {
      aging_No: src.aging_No ? Number(src.aging_No) : 0,
      aging_Date: src.aging_Date || null,
      start_Gas_Reading: start,
      end_Gas_Reading: end,
      total_Consumption: toDecimal(src.total_Consumption) ?? end - start,
      temperature: toDecimal(src.temperature) ?? 0,
      shift: src.shift ?? "",
      in_Time: src.in_Time ?? "",
      out_Time: src.out_Time ?? "",
      total_Time: src.total_Time ?? "",
      created_By: src.created_By ?? 1,
    };

    const details = pickDetails(src);
    if (details) payload.agingDetails = details;

    return payload;
  };
  const saveAging = async (source) => {
    const payload = buildPayload(source);
    const res = await aging.saveOrUpdate(payload);

    const newNo = res?.data?.aging_No ?? res?.aging_No ?? payload.aging_No ?? 0;
    payload.aging_No = newNo;
    notify(
      newNo > 0 && (source.aging_No ?? 0) > 0 ? "Updated" : "Saved",
      "success",
    );
    return payload;
  };
  const normalizeAgingForRow = (api) => {
    const details = (api.agingDetails ?? api.details ?? []).map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? api.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? "",
      quantity: toDecimal(d.quantity) ?? "",
      hardness: toDecimal(d.hardness) ?? "",
      remark: d.remark ?? "",
      po_No: d.po_No ?? "",
      approved_Pcs: d.approved_Pcs ?? 0,
    }));

    return {
      ...api,
      aging_Date: (api.aging_Date || "").split("T")[0] || "",
      start_Gas_Reading: api.start_Gas_Reading ?? "",
      end_Gas_Reading: api.end_Gas_Reading ?? "",
      total_Consumption: api.total_Consumption ?? "",
      temperature: api.temperature ?? "",
      shift: api.shift ?? "",
      in_Time: api.in_Time ?? "",
      out_Time: api.out_Time ?? "",
      total_Time: api.total_Time ?? "",
      status: api.status === true ? "Done" : (api.status ?? ""),
      details,
      agingDetails: details,
    };
  };
  const changeDetailQty = (parentId, detailIndex, value) => {
    setDraftRows((prev) => {
      const base =
        prev[parentId] ??
        isAgingData.find((r) => r.aging_No === parentId) ??
        {};
      const details = [...(base.agingDetails ?? base.details ?? [])];
      const d = { ...(details[detailIndex] ?? {}) };
      d.quantity = value;
      details[detailIndex] = d;

      const next = { ...base, agingDetails: details, details };
      return { ...prev, [parentId]: next };
    });
  };

  const changeDetailHardness = (parentId, detailIndex, value) => {
    setDraftRows((prev) => {
      const base =
        prev[parentId] ??
        isAgingData.find((r) => r.aging_No === parentId) ??
        {};
      const details = [...(base.agingDetails ?? base.details ?? [])];

      const d = { ...(details[detailIndex] ?? {}) };
      d.hardness = value;

      details[detailIndex] = d;

      const next = { ...base, agingDetails: details, details };
      return { ...prev, [parentId]: next };
    });
  };

  const ensureQtyMatchesApproved = (source) => {
    const orig = source?.agingDetails ?? source?.details ?? [];
    if (!Array.isArray(orig) || !orig.length) {
      return { ok: false, fixed: false, fixedSource: source };
    }
    let changed = false;
    const details = orig.map((d) => {
      const ap = Number(d.approved_Pcs ?? 0);
      const q = Number(d.quantity ?? 0);
      if (!Number.isFinite(ap)) return { ...d };
      if (q !== ap) {
        changed = true;
        return { ...d, quantity: ap };
      }
      return { ...d };
    });

    const fixedSource = { ...source, agingDetails: details, details };
    const ok = details.every(
      (d) => Number(d.quantity ?? 0) === Number(d.approved_Pcs ?? 0),
    );
    return { ok, fixed: changed, fixedSource };
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const res = await aging.getById(id);
      const entity = res?.data ?? res;
      const record = Array.isArray(entity) ? entity[0] : entity;
      const normalized = normalizeAgingForRow(record || {});
      setDraftRows((prev) => ({ ...prev, [id]: normalized }));
      setEditingRows((prev) => new Set(prev).add(id));
    } catch (e) {
      notify(e?.response?.data?.message || "Failed to load record", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRowSave = async (id) => {
    const row = draftRows[id] ?? isAgingData.find((r) => r.aging_No === id);
    if (!row) return notify("Row not found.", "error");

    setIsSaving(true);
    try {
      await saveAging({ ...row, fromGrid: true });
      setEditingRows((prev) => {
        const n = new Set(prev);
        n.delete(id);
        return n;
      });
      setDraftRows((prev) => {
        const n = { ...prev };
        delete n[id];
        return n;
      });
      fetchAgingData();
    } catch (error) {
      notify("Failed to save row", "error");
    } finally {
      setIsSaving(false);
    }
  };
  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await saveAging(formData);
      setIsModelOpen(false);
      fetchAgingData();
      fetchQcDoneData();
    } catch (error) {
      notify("Failed to save record", "error");
    } finally {
      setIsSaving(false);
    }
  };

  const buildMarkDoneFromDetail = (detail, aging_No) => {
    if (!detail) return null;
    return {
      Aging_No: Number(aging_No ?? detail.aging_No ?? 0),
      Batch_Id: detail.batch_Id ?? "",
      Casting_No: detail.casting_No ?? "",
      Die_Id: detail.die_Id ?? null,
      Created_By: 1,
    };
  };

  const callMarkDone = async (payload) => {
    if (!payload || !payload.Aging_No || !payload.Batch_Id) {
      notify("Mark Done needs Aging No and Batch Id.", "warning");
      return;
    }
    try {
      await aging.MarkAgingDone(payload);
      notify("Marked as Done", "success");
      fetchAgingData();
      fetchQcDoneData();
    } catch (e) {
      console.error("MarkDone error:", e?.response?.data || e);
      notify(
        e?.response?.data?.message || "Failed to mark production as done",
        "error",
      );
    }
  };
  const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const validateQtyVsApproved = (source) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    const mismatches = [];

    for (let i = 0; i < details.length; i++) {
      const d = details[i];
      const qty = toNum(d.quantity);
      const ap = toNum(d.approved_Pcs);

      if (qty !== ap) {
        mismatches.push({
          index: i,
          batch_Id: d.batch_Id,
          die: d.dieNumber ?? d.die_Id ?? "",
          qty,
          ap,
        });
      }
    }
    return mismatches;
  };

  const saveThenMarkDoneFromSource = async (
    source,
    { closeForm = false } = {},
  ) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    if (!details.length) {
      notify("Add at least one detail before Mark Done.", "warning");
      return;
    }

    const { ok, fixed, fixedSource } = ensureQtyMatchesApproved(source);
    const toSave = fixed ? fixedSource : source;

    if (fixed) {
      notify("Qty adjusted to match Approved Pcs. Saving…", "info");
    }

    const saved = await saveAging(toSave);
    const finalAgingNo = saved.aging_No;
    const first = {
      ...((toSave.agingDetails ?? toSave.details ?? [])[0] || {}),
      aging_No: finalAgingNo,
    };

    const { ok: okAfter } = ensureQtyMatchesApproved(saved);
    if (!okAfter) {
      notify(
        "Qty must equal Approved Pcs for all details before Mark Done.",
        "error",
      );
      return;
    }

    const mdPayload = buildMarkDoneFromDetail(first, finalAgingNo);
    await callMarkDone(mdPayload);

    if (closeForm) setIsModelOpen(false);
    fetchQcDoneData();
  };
  const handleMarkDoneRow = async (row) => {
    setIsSaving(true);
    try {
      const source = draftRows[row.aging_No] ? draftRows[row.aging_No] : row;
      const mismatches = validateQtyVsApproved(source);

      const saved = await saveAging(source);

      const recheck = validateQtyVsApproved(saved);
      if (recheck.length) {
        notify(
          "Validation failed after save. Please re-check quantities.",
          "error",
        );
        return;
      }

      const finalAgingNo = saved.aging_No;
      const firstDetail = (saved.agingDetails ?? saved.details ?? [])[0];
      const mdPayload = buildMarkDoneFromDetail(firstDetail, finalAgingNo);
      await callMarkDone(mdPayload);
    } catch (error) {
      notify("Failed to mark done", "error");
    } finally {
      setIsSaving(false);
    }
  };

  // const handleMarkDoneRow = async (row) => {
  //   const source = draftRows[row.aging_No] ? draftRows[row.aging_No] : row;
  //   await saveThenMarkDoneFromSource(source, { closeForm: false });
  // };

  const handleFieldChange = (field, value) => {
    setSelectedQcData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAdd = async () => {
    if (selectedSeqs.length === 0) {
      notify("Please select at least one QC-Done row.", "warning");
      return;
    }

    setAdding(true);
    try {
      const payload = selectedSeqs.map(Number);
      const res = await aging.AddToAging(payload);
      const items = Array.isArray(res) ? res : res?.data || [];

      const rows = items.map((x) => ({
        batch_Id: x.batch_Id ?? "",
        die_Id: x.die_Id ?? "",
        dieNumber: x.dieNumber ?? "",
        casting_No: x.casting_No ?? "",
        cut_Length: x.cut_Length ?? "",
        po_No: String(x.order_No ?? x.so_No ?? ""),
        approved_Pcs: Number(x.approved_Pcs ?? 0),
        quantity: "",
        hardness: "",
        remark: "",
      }));
      setFormData((prev) => {
        const base =
          prev?.aging_No != null
            ? prev
            : {
                aging_No: 0,
                aging_Date: "",
                start_Gas_Reading: "",
                end_Gas_Reading: "",
                total_Consumption: "",
                temperature: "",
                shift: "",
                in_Time: "",
                out_Time: "",
                total_Time: "",
                created_By: userId,
                agingDetails: [],
              };
        return { ...base, agingDetails: rows };
      });

      setSelectedQcData((prev) => ({ ...(prev || {}), agingDetails: rows }));
      setIsActiveTab("aging");
      setIsModelOpen(true);
      setIsEditing(false);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Aging",
        "error",
      );
    } finally {
      setAdding(false);
    }
  };

  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          checked={
            isQcDoneData.length > 0 &&
            isQcDoneData.every((r) => selectedSeqs.includes(r.seq_No))
          }
          onChange={(e) => {
            if (e.target.checked) {
              const pageIds = isQcDoneData.map((r) => r.seq_No);
              setSelectedSeqs((prev) =>
                Array.from(new Set([...prev, ...pageIds])),
              );
            } else {
              const pageSet = new Set(isQcDoneData.map((r) => r.seq_No));
              setSelectedSeqs((prev) => prev.filter((id) => !pageSet.has(id)));
            }
          }}
        />
      ),
      render: (_v, row) => (
        <input
          type="checkbox"
          checked={selectedSeqs.includes(row.seq_No)}
          onChange={(e) => {
            const id = Number(row.seq_No);
            setSelectedSeqs((prev) =>
              e.target.checked ? [...prev, id] : prev.filter((x) => x !== id),
            );
          }}
        />
      ),
    },

    { key: "order_No", label: "Order" },
    { key: "batch_Id", label: "Batch" },
    { key: "casting_No", label: "Casting" },
    { key: "dieNumber", label: "Die" },
    { key: "approved_Pcs", label: "Appr Pcs" },
    { key: "current_Weight", label: "Current Wt" },
    { key: "cut_Length", label: "Cut Length" },
    {
      key: "dispatch_Date",
      label: "Dispatch Date",
      render: (value) => formatDate(value),
    },
    {
      key: "packing_Instructions",
      label: "Packing Inst",
    },
    { key: "general_Notes", label: "General Notes" },
  ];

  const renderCell = (
    row,
    field,
    { type = "text", step, align = "right" } = {},
  ) => {
    const editable = editingRows.has(row.aging_No);
    const value = row[field] ?? "";

    if (editable) {
      return (
        <input
          type={type}
          step={step}
          className={`w-full bg-white border border-blue-400 rounded px-1.5 py-1 outline-none focus:ring-1 focus:ring-blue-500 text-[12px] shadow-sm text-${align}`}
          value={value}
          onChange={(e) => changeDraft(row.aging_No, field, e.target.value)}
        />
      );
    }

    return (
      <span
        className={`block px-2 py-1 text-slate-700 font-medium text-${align}`}
      >
        {value || value === 0 ? value : "-"}
      </span>
    );
  };

  return (
    <>
      <div>
        <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100 mb-6">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-6 mb-1">
            <div className="space-y-1">
              <h2 className="text-2xl font-bold text-slate-800 tracking-tight flex items-center gap-2">
                Aging Plan View
              </h2>
              <p className="text-sm text-slate-500 font-medium">
                Manage and track customer sales orders efficiently
              </p>
            </div>

            <div className="inline-flex p-1 bg-slate-200/50 rounded-xl backdrop-blur-sm">
              <button
                onClick={() => handleTabChange("qc-done")}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActiveTab === "qc-done"
                    ? "bg-white text-primary shadow-sm"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <LayoutGrid size={18} /> Aging Pending
              </button>
              <button
                onClick={() => handleTabChange("aging")}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  isActiveTab === "aging"
                    ? "bg-white text-primary shadow-sm"
                    : "text-slate-600 hover:text-slate-800"
                }`}
              >
                <RiHistoryLine size={18} /> Aging Done
              </button>
            </div>
          </div>

          {isActiveTab === "qc-done" && (
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="relative w-full sm:w-80 group">
                <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                  <LiaSearchSolid className="h-5 w-5 text-slate-400 group-focus-within:text-blue-500 transition-colors" />
                </div>
                <input
                  type="text"
                  className="w-full bg-slate-50 border border-slate-200 py-2.5 pl-11 pr-10 rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all placeholder:text-slate-400 text-sm"
                  placeholder="Search by order, customer..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery("")}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-red-500 transition-colors"
                  >
                    <MdClose size={20} />
                  </button>
                )}
              </div>

              <div className="flex items-center gap-3 w-full sm:w-auto">
                <Button
                  text={`Add Aging (${selectedSeqs.length})`}
                  icon={LiaHornbill}
                  disabled={selectedIds.length === 0}
                  onClick={handleAdd}
                  className={`w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-2.5 rounded-xl font-bold text-sm transition-all duration-300 ${
                    selectedSeqs.length > 0
                      ? "bg-orange text-white shadow-lg shadow-orange-200 hover:bg-orange-700 hover:-translate-y-0.5 active:scale-95 cursor-pointer opacity-100 visibility-visible"
                      : "bg-slate-100 text-slate-400 cursor-not-allowed opacity-60"
                  }`}
                  iconSpacing="mr-2"
                  iconColor={
                    selectedSeqs.length > 0 ? "text-white" : "text-slate-400"
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-slate-200 rounded-xl shadow-inner bg-white"
          style={{ height: "calc(100vh - 320px)" }}
        >
          {isActiveTab === "qc-done" && (
            <div className="min-w-max">
              <Table
                columns={columns}
                data={isQcDoneData}
                showActions={false}
              />
            </div>
          )}
          {isActiveTab === "aging" &&
            (loading ? (
              <Loader />
            ) : (
              <div className="relative border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white">
                <div className="overflow-x-auto overflow-y-auto max-h-[calc(100vh-340px)]">
                  <table className="w-full text-[13px] text-left border-separate border-spacing-0">
                    <thead className="bg-gray-50 sticky top-0 z-30 shadow-sm">
                      <tr className="text-[11px] font-semibold text-gray-600 text-center uppercase tracking-wider">
                        <th className="p-3 border-b border-gray-200"></th>
                        {/* <th className="p-3 border-b border-gray-200">✓</th> */}
                        <th className="p-3 border-b border-gray-200">
                          AGING NO
                        </th>
                        <th className="p-3 border-b border-gray-200">
                          AGING DATE
                        </th>
                        <th className="p-3 border-b border-gray-200 ">
                          START GAS
                        </th>
                        <th className="p-3 border-b border-gray-200">
                          END GAS
                        </th>
                        <th className="p-3 border-b border-gray-200">
                          CONSUMPTION
                        </th>
                        <th className="p-3 border-b border-gray-200">TEMP.</th>
                        <th className="p-3 border-b border-gray-200">SHIFT</th>
                        <th className="p-3 border-b border-gray-200">IN</th>
                        <th className="p-3 border-b border-gray-200">OUT</th>
                        <th className="p-3 border-b border-gray-200">TOTAL</th>
                        <th className="p-3 border-b border-gray-200">STATUS</th>
                        <th className="p-3 border-b border-gray-200 ">
                          Actions
                        </th>
                      </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                      {isAgingData.map((row, index) => {
                        const id =
                          row.aging_No ??
                          `${row.so_No}-${row.batch_Id}-${index}`;
                        const isOpen = expandedRows.has(id);
                        const isEditingRow = editingRows.has(id);
                        const d = isEditingRow ? (draftRows[id] ?? row) : row;

                        const isRowEditable = (id) => editingRows.has(id);

                        return (
                          <>
                            <tr
                              key={index}
                              className={`transition-colors duration-150  ${
                                isRowEditable(id)
                                  ? "bg-blue-50/50"
                                  : "hover:bg-gray-50"
                              }`}
                            >
                              <td className="p-2">
                                <button onClick={() => toggleExpand(id)}>
                                  {isOpen ? (
                                    <IoMdArrowDropdown />
                                  ) : (
                                    <IoMdArrowDropright />
                                  )}
                                </button>
                              </td>
                              {/* <td className="p-2">
                                <input
                                  type="checkbox"
                                  checked={
                                    isQcDoneData.length > 0 &&
                                    selectedIds.length ===
                                      isQcDoneData
                                        .filter((i) => i?.seq_No)
                                        .map((i) => i.seq_No).length
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      const allIds = isQcDoneData
                                        .filter((i) => i?.seq_No)
                                        .map((i) => i.seq_No);
                                      setSelectedIds(allIds);
                                    } else {
                                      setSelectedIds([]);
                                    }
                                  }}
                                />
                              </td> */}
                              <td className="p-2 text-center font-bold text-slate-800">
                                {row.aging_No}
                              </td>
                              <td className="p-2 text-center font-semibold text-slate-800">
                                {formatDate(row.aging_Date)}
                              </td>

                              <td className="p-2">
                                {renderCell(d, "start_Gas_Reading", {
                                  align: "right",
                                })}
                              </td>

                              <td className="p-2">
                                {renderCell(d, "end_Gas_Reading", {
                                  align: "right",
                                })}
                              </td>

                              <td className="p-2">
                                {renderCell(d, "total_Consumption", {
                                  align: "right",
                                })}
                              </td>

                              <td className="p-2">
                                {renderCell(d, "temperature", {
                                  align: "right",
                                })}
                              </td>
                              <td className="p-2">
                                {renderCell(d, "shift", { align: "left" })}
                              </td>

                              <td className="p-2">
                                {renderCell(d, "in_Time", {
                                  type: "time",
                                  align: "right",
                                })}
                              </td>
                              <td className="p-2">
                                {renderCell(d, "out_Time", {
                                  type: "time",
                                  align: "right",
                                })}
                              </td>
                              <td className="p-2">
                                {renderCell(d, "total_Time", {
                                  type: "time",
                                  align: "right",
                                })}
                              </td>

                              <td className="p-2 text-center font-bold text-blue-800">
                                {row.status}
                              </td>
                              <td className="p-2 text-center">
                                {!isEditingRow ? (
                                  <div className="inline-flex gap-2">
                                    <button
                                      className="p-1.5 bg-blue-50 text-blue-600 rounded hover:bg-blue-100"
                                      onClick={() => handleEdit(row.aging_No)}
                                      disabled={isSaving}
                                    >
                                      <MdEdit size={16} />
                                    </button>
                                    <Button
                                      className="p-1.5 bg-gray-100 text-gray-600 rounded hover:bg-gray-200"
                                      onClick={() => handleMarkDoneRow(row)}
                                      icon={AiOutlineCheck}
                                      loading={isSaving}
                                      loadingText=""
                                    />
                                  </div>
                                ) : (
                                  <div className="inline-flex gap-2">
                                    <Button
                                      className="p-1.5 bg-green-100 text-green-700 rounded hover:bg-green-200"
                                      onClick={() => handleRowSave(d.aging_No)}
                                      icon={IoIosSave}
                                      loading={isSaving}
                                      loadingText=""
                                    />

                                    <button
                                      className="p-1.5 bg-red-100 text-red-700 rounded hover:bg-red-200"
                                      onClick={() => cancelEdit(id)}
                                      disabled={isSaving}
                                    >
                                      <IoCloseSharp size={16} />
                                    </button>
                                  </div>
                                )}
                              </td>
                            </tr>
                            {expandedRows.has(row.aging_No) && (
                              <tr>
                                <td
                                  colSpan={15}
                                  className="bg-slate-50/50 p-4 border-b border-gray-200"
                                >
                                  <div className="overflow-hidden rounded-lg border border-gray-200 shadow-sm bg-white">
                                    <table className="w-full text-left border-separate border-spacing-0">
                                      <thead className="bg-gray-100/80">
                                        <tr className="text-[10px] font-bold text-gray-500  uppercase tracking-wider">
                                          <th className="px-4 py-2 border-b border-r border-gray-200">
                                            Order No
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200">
                                            Batch
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200">
                                            Die
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200">
                                            Cut Length
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200 text-center">
                                            Approved Pcs
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200 text-center">
                                            Qty
                                          </th>
                                          <th className="px-4 py-2 border-b border-r border-gray-200 text-center">
                                            Hardness
                                          </th>
                                          <th className="px-4 py-2 border-b border-gray-200">
                                            Remark
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="divide-y divide-gray-100 bg-white">
                                        {(row.details ?? []).length ? (
                                          row.details.map((detail, i) => {
                                            const parentId =
                                              row.aging_No ??
                                              `${row.so_No}-${row.batch_Id}-${index}`;
                                            const isEditingRow =
                                              editingRows.has(parentId);
                                            const editedParent =
                                              draftRows[parentId];
                                            const editedDetail =
                                              editedParent?.agingDetails?.[i] ??
                                              detail;

                                            return (
                                              <tr
                                                key={i}
                                                className="hover:bg-blue-50/30 transition-colors"
                                              >
                                                <td className="px-4 py-2 border-r border-gray-100 font-medium text-slate-700">
                                                  {detail.po_No}
                                                </td>
                                                <td className="px-4 py-2 border-r border-gray-100 text-slate-600">
                                                  {detail.batch_Id}
                                                </td>
                                                <td className="px-4 py-2 border-r border-gray-100 text-slate-600">
                                                  {detail.dieNumber}
                                                </td>
                                                <td className="px-4 py-2 border-r border-gray-100 text-right font-mono">
                                                  {detail.cut_Length}
                                                </td>
                                                <td className="px-4 py-2 border-r border-gray-100 text-right font-bold text-slate-700">
                                                  {detail.approved_Pcs}
                                                </td>
                                                <td className="px-4 py-2 border-r border-gray-100 text-right font-bold text-primary">
                                                  {detail.quantity}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right">
                                                  {renderCell(
                                                    editedDetail,
                                                    "hardness",
                                                  )}
                                                </td>

                                                <td className="px-4 py-2 italic text-slate-400">
                                                  {detail.remark || "-"}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td
                                              className="p-4 text-center text-gray-400 italic"
                                              colSpan={8}
                                            >
                                              No details available for this
                                              aging record.
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
        </div>
        <div className="flex justify-center mt-6">
          <div className="bg-[#1e293b] text-white px-8 py-3 rounded-2xl shadow-2xl flex items-center gap-12 border border-slate-700">
            <div className="flex flex-col items-center">
              <span className="text-[10px] uppercase tracking-[2px] text-slate-400 font-bold">
                {isActiveTab === "qc-done"
                  ? "Total Pending Pcs"
                  : "Total Aging Done"}
              </span>
              <span className="text-xl font-black">
                {isActiveTab === "qc-done"
                  ? isQcDoneData
                      .reduce(
                        (sum, row) => sum + Number(row.approved_Pcs || 0),
                        0,
                      )
                      .toLocaleString()
                  : isAgingData.length.toLocaleString() + " Records"}
              </span>
            </div>

            {isActiveTab === "qc-done" && (
              <>
                <div className="h-8 w-[1px] bg-slate-600"></div>
                <div className="flex flex-col items-center">
                  <span className="text-[10px] uppercase tracking-[2px] text-orange-400 font-bold">
                    Selected Pcs
                  </span>
                  <span className="text-xl font-black text-orange-400">
                    {isQcDoneData
                      .filter((r) => selectedSeqs.includes(r.seq_No))
                      .reduce(
                        (sum, row) => sum + Number(row.approved_Pcs || 0),
                        0,
                      )
                      .toLocaleString()}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {isModelOpen && formData && (
        <AgingForm
          data={selectedQcData}
          onChange={handleFieldChange}
          setFormData={setFormData}
          formData={formData}
          onSubmit={handleSubmit}
          onClose={() => {
            setIsModelOpen(false);
            setSelectedQcData(null);
          }}
          refreshList={fetchQcDoneData}
          refreshAgingList={fetchAgingData}
          onMarkDone={() =>
            saveThenMarkDoneFromSource(formData, { closeForm: true })
          }
          isSaving={isSaving}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default Aging;
